export default function (axios, api) {
  return {
    state: {
      campaigns: [],
      campaign: {
        title: {
          rendered: null
        },
        background: { url: false }
      },
      ncCampaign: {
        title: {
          rendered: null
        },
        background: { url: false }
      }
    },

    getters: {
      campaigns: state => state.campaigns,
      campaign: state => state.campaign,
      ncCampaign: state => state.ncCampaign,
      campaignBg: state => state.campaign.background.url,
      nationalCouncilCatId: state => state.nationalCouncilCatId
    },

    actions: {
      submitCampaign (_, campaign) {
        return api.submitCampaign(campaign)
      },

      getCampaigns ({ commit }) {
        return api.fetchCampaigns().then(campaigns => {
          commit('setCampaigns', campaigns)
        })
      },

      getCampaign ({ commit }, slug) {
        commit('clearHero')

        return api.fetchCampaign(slug).then(campaign => {
          commit('setCampaign', campaign)
          commit('setHero', campaign.icon)

          let tabs = [{ title: 'Информация', link: { name: 'campaign-info', params: { slug } } }]

          if (campaign.news.length > 0) {
            tabs.push({ title: 'Новини', link: { name: 'campaign-news', params: { slug } } })
          }

          if (campaign.questionnaire) {
            tabs.push({ title: 'Гласуване', link: { name: 'campaign-voting', params: { slug } } })
          }

          commit('setTabs', tabs)
        })
      },

      getNCCampaigns ({ commit, state }) {
        return api.fetchNCCampaigns(state.nationalCouncilCatId).then(campaigns => {
          commit('setCampaigns', campaigns)
        })
      },

      getNCCampaign ({ commit, state }, slug) {
        return api.fetchNCCampaign(slug, state.nationalCouncilCatId).then(campaign => {
          commit('setNCCampaign', campaign)
        })
      },

      getNationalCouncilCategoryId ({ commit }) {
        return api.fetchNationalCouncilCategory().then(result => {
          commit('setNationalCouncilCatId', result.categoryId)
        })
      }
    },

    mutations: {
      setCampaigns (state, campaigns) {
        state.campaigns = campaigns
      },

      setCampaign (state, campaign) {
        state.campaign = campaign
      },

      setNCCampaign (state, campaign) {
        state.ncCampaign = campaign
      },

      setNationalCouncilCatId (state, id) {
        state.nationalCouncilCatId = id
      }
    }
  }
}
